import { observer } from 'mobx-react-lite'
import { FC, useEffect, useState } from 'react'
import usePlayTracking from '../../../hooks/usePlayTracking'
import { useWindowSize } from '../../../hooks/useWindowSize'
import { styled } from '../../../lib/stitches'
import { useTreeState } from '../../../stores/Root'
import { Column, Row } from '../../core/Components'
import { gray1 } from '../../platform/color'
import SampleTimelineControls from '../../player/sample/SampleTimelineControls'
import { GLOBAL_PLAYER_TABLET_HEIGHT } from './Common'
import ExtraControls from './ExtraControls'
import MediaDNA from './MediaDNA'
import MediaTitleSection from './MediaTitleSection'
import MobilePlayerPage from './MobilePlayerPage'
import PlayerControlsSection from './PlayerControlsSection'

const backgroundColor = gray1

const MobileSampleTimelineContainer = styled(Row, {
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0px 16px'
})

const MainControlsContainer = styled(Row, {
  zIndex: 20,
  width: '100%',
  height: '90%',
  backgroundColor,
  justifyContent: 'space-between',
  alignItems: 'center',
  '@mobile': {
    height: '100%'
  }
})

const GlobalPlayerContainer = styled(Column, {
  zIndex: 15,
  width: `100%`,
  maxWidth: '100vw',
  height: '115px',
  position: 'fixed',
  overflow: 'visible',
  bottom: '0',
  alignItems: 'center',
  boxShadow: '0px 2px 20px rgba(0, 0, 0, 0.1)',
  backgroundColor,
  '@mobile': {
    height: GLOBAL_PLAYER_TABLET_HEIGHT
  }
})

const GlobalPlayer: FC = () => {
  const [mobilePlayerPageOpen, setMobilePlayerPageOpen] = useState<boolean>(false)
  const { globalPlayer } = useTreeState()
  usePlayTracking({ arpMediaId: globalPlayer.arpMediaIndex, audio: globalPlayer.getAudio() })
  const { isBreakpoint } = useWindowSize()
  const isMobile = !isBreakpoint('tablet')

  const toggleMobilePlayerPageOpen = () => setMobilePlayerPageOpen(!mobilePlayerPageOpen)

  useEffect(() => {
    return () => globalPlayer.stop()
  }, [])

  if (!globalPlayer || globalPlayer.arpMediaIndex === null) return null
  return (
    <>
      <GlobalPlayerContainer onClick={toggleMobilePlayerPageOpen} animateAppear>
        <MediaDNA />
        <MainControlsContainer>
          <MediaTitleSection isMobile={isMobile} />
          <PlayerControlsSection isMobile={isMobile} />
          <ExtraControls />
        </MainControlsContainer>
        {isMobile && (
          <MobileSampleTimelineContainer>
            <SampleTimelineControls
              audio={globalPlayer.getAudio()}
              hideLabels
              style={{ width: '100%' }}
            />
          </MobileSampleTimelineContainer>
        )}
      </GlobalPlayerContainer>
      {isMobile && mobilePlayerPageOpen && <MobilePlayerPage close={toggleMobilePlayerPageOpen} />}
    </>
  )
}

export default observer(GlobalPlayer)
